<template>
  <div class="row align-center" id="filtercomponent">
    <div class="small-10 medium-10 large-11 columns">
      <div class="filterwrapper">
        <div class="visual-divider">
          <div class="filterHeader">
            <p class="filterTitle">{{ $translate("UMA_LANG_FACULDADE_FILTRARPOR") }}:</p>
            <div class="filter_tab">
              <a v-for="ciclo in ciclos"
                 :key="ciclo.value"
                 @click.prevent="filterCiclo(ciclo)"
                 :class="[{active: currentCiclo.value == ciclo.value}, faculdadename ]">
                {{ciclo.label}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterHeader",
  props:["ciclos","currentCiclo","faculdadename"],
  emits: ["selectedfilter"],
  methods:{
    filterCiclo(ciclo){
      this.$emit("selectedfilter",ciclo);
    }
  }
}
</script>

<style scoped lang="scss">
@import "../global.scss";

/*466-474*/
.visual-divider{
  border-bottom: 1px solid #b9b6b6;;
}

.visual-divider.selectFilter{
  border-bottom: 0;
}

.visual-divider.selectFilter.show{
  border-bottom: 1px solid #ccc;
}

/*478*/
.filterHeader{
  position: relative;
}

/*482*/
.filterTitle{
  font-family: "Montserrat Bold";
  padding-left: 16px;
  color: #b9b6b6;
  text-transform: uppercase;
  letter-spacing: 0.15px;
  font-size: 15px;
}

/*490-508*/
.filter_tab{
  position: absolute;
  right: 0;
  top: 0;
}

.filter_tab a{
  margin-left: 60px;
  border-bottom: 4px solid transparent;
  -webkit-transition: border .3s ease-in-out;
  transition: border .3s ease-in-out;
  padding-bottom: 16px;
  text-transform: uppercase;
  font-family: "Montserrat SemiBold";
  letter-spacing: 0.15px;
  color: #b9b6b6;
  font-size: 15px;
}

.filter_tab a:hover {
  color: #595858;
}

.filter_tab a.active{
  color: #333333;
  border-bottom: 4px solid #4A74F2;
  -webkit-transition: border .3s ease-in-out;
  transition: border .3s ease-in-out;
}

.filterwrapper {
  padding-right: 65px;
  padding-left: 65px;
}



@media (max-width : 1500px) {
#filtercomponent {
  padding-right: 25px;
  padding-left: 25px;
}
  .filterwrapper {
    padding-right: 0px;
    padding-left: 0px;
  }


}

/*1083*/
@media (min-width : 840px) and (max-width:950px){

  .filterTitle{
    font-size: 14px;
  }

  .filter_tab a{
    font-size: 14px;
  }

}

@media (max-width: 839px) {
  #filtercomponent{
    display: none;
  }
}

.filter_tab a{
  background-color: transparent !important;
}

.filter_tab a.active.artesehumanidades{
  border-color: $ahline;
}

.filter_tab a.active.cienciasexatasedaengenharia{
  border-color: $ceeline;
}

.filter_tab a.active.cienciassociais{
  border-color: $csline;
}

.filter_tab a.active.cienciasdavida{
  border-color: $cvhline;
}

.filter_tab a.active.escolasuperiordetecnologiasegestao{
  border-color: $tghline;
}

.filter_tab a.active.escolasuperiordesaude{
  border-color: $ssline;
}
</style>